module.exports = __webpack_public_path__ + "img/0Q3A7263_L_Foamcore_MockedUp.91e8b626.jpg";